/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./copy-button.vue?vue&type=template&id=a5d5d82a&"
import script from "./copy-button.vue?vue&type=script&lang=ts&"
export * from "./copy-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports